import React from "react";
import { Apple, Clock, Globe, Play } from "lucide-react";
import { Link } from "@remix-run/react";
import { M_URI_FULL_ROOT_PATH } from "~/src/types/openTypes";
import { trackGAClick } from "~/src/logic/GoogleAnalyticsLogic";
import { publicPath } from "@remix-run/dev/server-build";

const DownloadMobileApp = () => {
  return (
    <>
      <div className="mt-8 flex justify-center gap-4 flex-wrap">
        {/* App Store */}
        <a
          // href="https://apps.apple.com/app/your-app-id"
          // target="_blank"
          rel="noopener noreferrer"
          className="flex items-center bg-black text-white rounded-lg px-4 py-3 shadow hover:bg-gray-900 transition"
        >
          <Apple className="w-6 h-6 mr-3" />
          {/*<Clock className="w-6 h-6 mr-3"></Clock>*/}

          <div className="text-left">
            {/*<div className="text-xs">Download on the</div>*/}
            <div className="text-xs">Coming soon</div>
            <div className="text-sm font-semibold">App Store</div>
          </div>
        </a>

        {/* Google Play */}
        <a
          href="https://play.google.com/store/apps/details?id=tech.cybugo.waypick"
          target="_blank"
          rel="noopener noreferrer"
          // className="flex items-center bg-black text-white rounded-lg px-4 py-3 shadow hover:bg-gray-900 transition"
          className="flex items-center bg-black text-white rounded-lg px-4 py-3"
        >
        <img src="images/getitgoogleplay.svg" alt="Get WayPick on Google Play"/>
          {/*<Play className="w-6 h-6 mr-3" />*/}
          {/*/!*<Clock className="w-6 h-6 mr-3"></Clock>*!/*/}
          {/*<div className="text-left">*/}
          {/*  <div className="text-xs">Get it on</div>*/}
          {/*  <div className="text-sm font-semibold">Google Play</div>*/}
          {/*</div>*/}
        </a>

        {/* Web version */}
        <Link
          to={M_URI_FULL_ROOT_PATH}
          onClick={(e) => {
            trackGAClick("landing", 'visit-web-version');
          }}
          className="flex items-center bg-black text-white rounded-lg px-4 py-3 shadow hover:bg-gray-900 transition"
        >
          {/*<div className="border-white border rounded-lg mx-auto">*/}
            <Globe className="w-6 h-6 mr-3" color="#3ea0f1" />
            <div className="text-left ">
              <div className="text-xs">Use the</div>
              <div className="text-sm font-semibold">Web Version</div>
            </div>
          {/*</div>*/}
        </Link>
      </div>
    </>
  );
}

export default DownloadMobileApp;